// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__zxZDC","updatedAt":"styles_updatedAt__BU4fW"};